export function normalisePage(value) {
  return String(value || '').trim().toLowerCase() || 'home';
}

function closeMobileMenu(documentRoot, toggle, menu) {
  const body = documentRoot.body;

  menu.hidden = true;
  toggle.setAttribute('aria-expanded', 'false');
  body?.classList.remove('menu-open');
}

function initialiseMenu(documentRoot) {
  const toggle = documentRoot.querySelector('.js-menu-toggle');
  const menu = documentRoot.querySelector('.js-mobile-menu');
  const closeButton = documentRoot.querySelector('.js-menu-close');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeMobileMenu(documentRoot, toggle, menu);
      return;
    }

    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    documentRoot.body?.classList.add('menu-open');
    closeButton?.focus();
  });

  closeButton?.addEventListener('click', () => closeMobileMenu(documentRoot, toggle, menu));

  documentRoot.querySelectorAll('.mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => closeMobileMenu(documentRoot, toggle, menu));
  });

  documentRoot.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      closeMobileMenu(documentRoot, toggle, menu);
      toggle.focus();
    }
  });
}

function initialiseAnchorNavigation(documentRoot) {
  documentRoot.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href')?.slice(1);
      const target = targetId ? documentRoot.getElementById(targetId) : null;

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', `#${targetId}`);
    });
  });
}

function initialiseProgram(documentRoot) {
  const sessions = [...documentRoot.querySelectorAll('details.program__item--toggle')];

  sessions.forEach((session) => {
    session.addEventListener('toggle', () => {
      if (!session.open) return;

      sessions.forEach((otherSession) => {
        if (otherSession !== session) otherSession.open = false;
      });
    });
  });
}

function initialiseShare(documentRoot) {
  documentRoot.querySelectorAll('.js-share').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      const originalLabel = button.textContent;
      const shareData = {
        title: documentRoot.title,
        text: 'Форум Агроинвестора',
        url: window.location.href,
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(window.location.href);
          if (!button.querySelector('svg')) {
            button.textContent = 'Ссылка скопирована';
            window.setTimeout(() => { button.textContent = originalLabel; }, 2200);
          }
        }
      } catch {
        if (!button.querySelector('svg')) {
          button.textContent = originalLabel;
        }
      }
    });
  });
}

async function submitRegistration(form) {
  const response = await fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

  const data = await response.json().catch(() => ({}));
  return { ok: response.ok && data.ok, data };
}

export function applyServerErrors(form, errors) {
  Object.entries(errors).forEach(([fieldName, fieldErrors]) => {
    const field = form.querySelector(`[name="${fieldName}"]`);
    if (!field) return;

    field.classList.add('has-error');
    const message = fieldErrors.map((entry) => entry.message).join(' ');

    let errorBox = form.querySelector(`.js-field-error[data-field="${fieldName}"]`);
    if (!errorBox) {
      errorBox = document.createElement('p');
      errorBox.className = 'form-error js-field-error';
      errorBox.dataset.field = fieldName;
      field.closest('.form__item')?.append(errorBox);
    }
    errorBox.textContent = message;
  });
}

function clearFieldErrors(form) {
  form.querySelectorAll('.has-error').forEach((field) => field.classList.remove('has-error'));
  form.querySelectorAll('.js-field-error').forEach((errorBox) => errorBox.remove());
}

function initialiseRegistration(documentRoot) {
  documentRoot.querySelectorAll('.js-registration-form').forEach((form) => {
    const error = form.querySelector('.js-form-error');
    const success = form.parentElement?.querySelector('.js-form-success');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearFieldErrors(form);

      if (!form.checkValidity()) {
        form.querySelectorAll('[required]:invalid').forEach((field) => field.classList.add('has-error'));
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton?.setAttribute('disabled', '');

      try {
        const { ok, data } = await submitRegistration(form);
        if (!ok) {
          if (data.errors) {
            applyServerErrors(form, data.errors);
          } else if (error) {
            error.hidden = false;
          }
          return;
        }
        form.hidden = true;
        if (success) success.hidden = false;
      } finally {
        submitButton?.removeAttribute('disabled');
      }
    });
  });
}

export function initialiseSite(documentRoot) {
  if (!documentRoot?.querySelector) return;

  initialiseMenu(documentRoot);
  initialiseAnchorNavigation(documentRoot);
  initialiseProgram(documentRoot);
  initialiseShare(documentRoot);
  initialiseRegistration(documentRoot);
}
